module.exports = __webpack_public_path__ + "img/scrollToDownIcon.9530cc49.svg";